import styled from "styled-components";
import { borderRadius, borderWidth, mediaQueries, shadows, spacing, typographyMixin, zIndex } from "@magicbi/ui-library";

/** Prototype `.nt-stack`: fixed bottom right, 380px, newest at the bottom; full width on phones. */
export const Region = styled.section<{ $lift: number }>`
  position: fixed;
  z-index: ${zIndex.toast};
  right: max(${spacing[4]}, env(safe-area-inset-right, 0px));
  bottom: calc(${spacing[4]} + env(safe-area-inset-bottom, 0px) + ${({ $lift }) => $lift}rem);
  width: 23.75rem;
  max-width: calc(100vw - 2rem);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${spacing[2]};
  pointer-events: none;

  ${mediaQueries.down.xs} {
    left: max(${spacing[4]}, env(safe-area-inset-left, 0px));
    width: auto;
    max-width: none;
  }
`;

export const Pills = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${spacing[1]};
`;

/** Prototype `.nt-pill`. */
export const Pill = styled.button`
  pointer-events: auto;
  display: inline-flex;
  align-items: center;
  height: 2rem;
  padding: 0 ${spacing[3]};
  border: 1px solid ${({ theme }) => theme.colors.border.stroke};
  border-radius: ${borderRadius.full};
  background: ${({ theme }) => theme.colors.surface.primary};
  color: ${({ theme }) => theme.colors.text.primary};
  ${typographyMixin("caption", 2)}
  box-shadow: ${shadows.component.popover};
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.colors.surface.secondary};
  }

  &:focus-visible {
    outline: ${borderWidth[2]} solid ${({ theme }) => theme.colors.interactive.primary};
    outline-offset: ${spacing[0.5]};
  }
`;

export const List = styled.ol<{ $expanded: boolean }>`
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: ${spacing[2]};

  ${({ $expanded }) =>
    $expanded
      ? `
    pointer-events: auto;
    max-height: calc(100vh - 8rem);
    overflow-y: auto;
    overscroll-behavior: contain;
  `
      : ""}
`;

/** A toast centred at the bottom: of the viewport (fixed), or of a `ToastAnchor` region (absolute). */
export const CenterRegion = styled.section<{ $anchored: boolean }>`
  position: ${({ $anchored }) => ($anchored ? "absolute" : "fixed")};
  z-index: ${zIndex.toast};
  left: 50%;
  transform: translateX(-50%);
  bottom: ${({ $anchored }) => ($anchored ? spacing[7] : `calc(${spacing[7]} + env(safe-area-inset-bottom, 0px))`)};
  width: max-content;
  max-width: calc(100% - 2rem);
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[2]};
  pointer-events: none;
`;

export const CenterList = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${spacing[2]};
  max-width: 100%;
`;
